// app/blog/[slug]/page.tsx
"use client";

import ReactMarkdown from "react-markdown";
import Link from "next/link";

export default function MarkdownRenderer({ content }) {

  return (
    <div className="container max-w-4xl mx-auto p-4">
      <ReactMarkdown
        components={{
          h1: ({ children }) => (
            <h1 className="text-4xl font-bold mt-6">{children}</h1>
          ),
          h2: ({ children }) => (
            <h2 className="text-3xl font-semibold mt-5">{children}</h2>
          ),
          h3: ({ children }) => (
            <h3 className="text-2xl font-medium mt-4">{children}</h3>
          ),
          p: ({ children }) => (
            <p className="text-base leading-relaxed my-4">{children}</p>
          ),
          ul: ({ children }) => (
            <ul className="list-disc list-inside my-4">{children}</ul>
          ),
          ol: ({ children }) => (
            <ol className="list-decimal list-inside my-4">{children}</ol>
          ),
          li: ({ children }) => <li className="ml-4">{children}</li>,
          blockquote: ({ children }) => (
            <blockquote className="border-l-4 border-gray-400 pl-4 italic">
              {children}
            </blockquote>
          ),
          code: ({ children }) => (
            <code className="bg-gray-100 dark:bg-gray-800 px-2 py-1 rounded text-sm">
              {children}
            </code>
          ),
          pre: ({ children }) => (
            <pre className="bg-gray-900 text-white p-4 rounded overflow-x-auto">
              {children}
            </pre>
          ),
          a: ({ href, children }) =>
            href?.startsWith("http") ? (
              <a
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-500 hover:underline"
              >
                {children}
              </a>
            ) : (
              <Link href={href} className="text-blue-500 hover:underline">
                {children}
              </Link>
            ),
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
}
